module.exports = __webpack_public_path__ + "static/img/brush-twice.01b2c60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brush-twice.svg
// module id = p4rz
// module chunks = 0